import { Tooltip } from '@faxi/web-component-library';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { t } from 'i18next';
import { FC, ReactNode } from 'react';

import { StyledValueCurrencyBox } from './ValueCurrencyBox.styled';

type ValueEntry = {
  title: string;
  value?: number | string;
  tooltipInfo?: string;
};

export type ValueCurrencyBoxProps = {
  values: ValueEntry[];
  currency?: string;
  className?: string;
  error?: string;
  info?: ReactNode;
};

const ValueCurrencyBox: FC<ValueCurrencyBoxProps> = props => {
  const { values, className, error, info } = props;

  return (
    <StyledValueCurrencyBox
      className={classNames('cedolauto-value-currency-box', className)}
    >
      <div className="cedolauto-value-currency-box__container">
        {!error ? (
          values.map(item => (
            <div
              className="cedolauto-value-currency-box__container__values"
              key={item.title}
            >
              <p>{item.title}</p>

              <div>
                <strong
                  className={classNames(
                    'cedolauto-value-currency-box__container__values__value',
                    {
                      'cedolauto-value-currency-box__container__values__value--error':
                        item.value === t('ced-error_try_again'),
                    }
                  )}
                >
                  {item.value ?? 0}
                </strong>
                {item.tooltipInfo && (
                  <Tooltip
                    appendTo="parent"
                    theme="custom-tooltip"
                    content={item.tooltipInfo}
                  >
                    <div>
                      <Icon name="circle-info" />
                    </div>
                  </Tooltip>
                )}
              </div>
            </div>
          ))
        ) : (
          <p>{error}</p>
        )}
      </div>
      {info && <small>{info}</small>}
    </StyledValueCurrencyBox>
  );
};

export default ValueCurrencyBox;
